import React, { PropTypes } from 'react';
import Card from 'components/Card';
import cx from './ReviewList.scss';
import ReviewForm from './ReviewForm';
import Review from 'components/Review';
import BigNumber from 'components/BigNumber';

import { declension } from 'utils/lang';

import connectToStores from 'decorators/connectToStores';
import withStyles from 'decorators/withStyles';

@withStyles(cx)
@connectToStores({
	reviewForm: ({ state }) => ({
		newReview: state.review,
		added: state.added,
		formSending: state.sending,
	}),
	review: ({ state }) => ({
		reviews: state.reviews,
	}),
	ratings: ({ state }, props) => ({
		rating: state.ratings[props.coachId],
	}),
})
export default class ReviewList extends React.Component {
	static propTypes = {
		showReviewForm: PropTypes.bool.isRequired,
		programId: PropTypes.number.isRequired,
		coachId: PropTypes.number.isRequired,
		flux: PropTypes.object,
		newReview: PropTypes.object,
		formSending: PropTypes.bool,
		rating: PropTypes.object,
		reviews: PropTypes.object,
		added: PropTypes.bool,
	};

	render() {
		const {
			newReview,
			flux,
			formSending,
			reviews,
			showReviewForm,
			coachId,
			programId,
			rating,
			added,
		} = this.props;
		const reviewActions = flux.getActions('review');

		return (
			<Card>
				<div className={cx('stat')}>
					<BigNumber
						number={Number(rating.rating)}
						label={__('rating')}
						className={cx('number')}
						/>
					<BigNumber
						number={Number(rating.count)}
						label={declension(__('rates'), rating.count)}
						className={cx('number')}
						/>
				</div>

				<h2 className={cx('title')}>{__('reviews')}</h2>

				{(showReviewForm && !added) &&
					<div className={cx('form')}>
						<ReviewForm
							review={newReview}
							onChange={review => reviewActions.formUpdate(review)}
							onSubmit={() => reviewActions.createReview(newReview, coachId, programId)}
							sending={formSending}
							/>
					</div>
				}

				<div className={cx('list')}>
					{reviews.map(review =>
						<div key={review.get('id')} className={cx('item')}>
							<Review review={review} />
						</div>
					)}
				</div>
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/react/elements/ReviewList/ReviewList.js